export default __webpack_public_path__ + "static/media/pic03.9722388e.jpg";